<div class="row">
  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
    @if (element().title) {
      <nscf-title
        [id]="'anchor_' + element().id"
        [selector]="element().isFirstTitle ? 'h1' : 'h2'"
        [title]="element().title"
        class="block-title text-center"
      />
    }

    <nscf-youtube-wrapper [cover]="element().cover" [videoId]="element().youtubeVideoId" [legend]="element().legend" />

    @if (element().ctaLabel) {
      <a
        effy-button
        [size]="buttonSize.LARGE"
        [color]="buttonStyle.PRIMARY"
        [attr.href]="element()?.ctaUrl?.url"
        [attr.rel]="element()?.ctaUrl?.options?.attributes?.rel"
        [attr.target]="element()?.ctaUrl?.options?.attributes?.target"
        [attr.id]="element()?.ctaUrl?.options?.attributes?.id"
        [ngClass]="element()?.ctaUrl?.options?.attributes?.class"
        class="mt-8 mx-auto"
        [innerHTML]="element()?.ctaLabel"
      ></a>
    }
  </div>
</div>
